import { ConfigurableColumns } from '@/components/ConfigurableColumns';

import {
  GenericDateFunctionField,
  GenericRelativeDateDisplay,
} from '@/components/GenericDateFunctionField';
import { formatBytes } from '@/components/util';
import { Chip } from '@mui/material';
import { FunctionField } from 'react-admin';
import { DownloadFileButton } from './DataExportsCommandPannel';

export const columns: ConfigurableColumns[] = [
  {
    label: 'Created At',
    source: 'createdAt',
    sortable: true,
    GridComponent: GenericDateFunctionField,
    exportFn: record => record.createdAt?.toISOString(),
  },
  {
    label: 'Entity',
    source: 'collectionName',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) => <Chip label={record.collectionName} />,
    },
  },
  {
    label: 'Export Duration',
    source: 'exportDuration',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) =>
        record.exportDuration ? (
          <Chip
            label={`${record.exportDuration / 1000}s`}
            color="primary"
          />
        ) : (
          <Chip label="Pending" color="warning" />
        ),
    },
  },
  {
    label: 'Completed At',
    source: 'completedAt',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) =>
        record.completedAt ? (
          <GenericRelativeDateDisplay
            date={record.completedAt}
            color="success"
          />
        ) : (
          <Chip label="Pending" color="warning" />
        ),
    },
  },
  {
    label: 'Exported Records',
    source: 'exportedRecords',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) =>
        record.exportedRecords ? (
          <Chip label={record.exportedRecords} color="primary" />
        ) : (
          <Chip label="Pending" color="warning" />
        ),
    },
  },
  {
    label: 'File Size',
    source: 'fileSize',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) =>
        record.fileSize ? (
          <Chip
            label={formatBytes(record.fileSize)}
            color="primary"
          />
        ) : (
          <Chip label="Pending" color="warning" />
        ),
    },
  },
  {
    label: 'Download File',
    source: 'filePath',
    GridComponent: FunctionField,
    gridComponentProps: {
      render: (record: any) =>
        record.fileSize ? (
          <DownloadFileButton filePath={record.filePath} />
        ) : (
          <Chip label="Pending" color="warning" />
        ),
    },
  },
];
